import { render } from "./forth_question.vue?vue&type=template&id=63339266&scoped=true"
import script from "./forth_question.vue?vue&type=script&lang=js"
export * from "./forth_question.vue?vue&type=script&lang=js"

import "./forth_question.vue?vue&type=style&index=0&id=63339266&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63339266"]])

export default __exports__